import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-accordion',
			dom: {
				item: '.js-accordion-item',
				toggle: '.js-accordion-toggle',
				wrapper: '.js-accordion-wrapper',
				content: '.js-accordion-content'
			},
			classes: {
				active: 't-accordion__item_state_active'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		this.prevent = false;
		this.timeout = false;
		return this;
	}

	getDom() {
		this.$item = this.$el.find(this.options.dom.item);
		this.$toggle = this.$el.find(this.options.dom.toggle);
		this.$wrapper = this.$el.find(this.options.dom.wrapper);
		this.$content = this.$el.find(this.options.dom.content);
		return this;
	}

	onClick(event) {
		const self = this;
		self.prevent = true;
		const $item = $(event.currentTarget).closest(self.$item);
		self.$item.not($item).removeClass(self.options.classes.active);
		const $wrapper = $item.find(self.$wrapper);
		const $content = $item.find(self.$content);
		$wrapper.css({height: $content.outerHeight(true)});
		$item.toggleClass(self.options.classes.active);
		event.preventDefault();
		clearTimeout(self.timeout);
		self.timeout = setTimeout(function () {
			self.prevent = false;
			self.onResize();
		}, 1000);
		return self;
	}

	onResize() {
		const self = this;
		if (!self.prevent) {
			self.$item.each(function () {
				const $item = $(this);
				const $wrapper = $item.find(this.$wrapper);
				const $content = $item.find(this.$content);
				$wrapper.css({height: $content.outerHeight(true)});
			});
		}
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.$toggle.on('click', this.onClick.bind(this));
			this.$window.on('resize', this.onResize.bind(this));
			this.onResize();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/info/accordion.js